import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {IEmpresa, ILogin, ILoginResponse, ITipoUsuario} from '@core/models';
import {environment} from 'src/environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {ConectionService} from './conection.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AutologinService {
  // public baseUrl = `${environment.serverUrl}Usuario/`;

  constructor(
    private http: HttpClient,
    private cookies: CookieService,
    private connection: ConectionService,
    public router: Router,
  ) {}

  token: string = '';

  checkApiKey() {
    const cookie = this.cookies.check('apiKey');
    const session = sessionStorage.getItem('apiKey');
    if (cookie || session) {
      return true;
    } else {
      return false;
    }
  }
  checkToken() {
    const cookie = this.cookies.check('token');
    const session = sessionStorage.getItem('token');
    if (cookie || session) {
      return true;
    } else {
      return false;
    }
  }

  setToken(token: string) {
    if (token === '') {
      return this.router.navigateByUrl('/login');
    }
    this.cookies.set('token', token);
    sessionStorage.setItem('token', token);
  }
  setApiKey(ak: string) {
    if (ak === '') {
      //TODO: redirigir a no-autorizado
      return this.router.navigateByUrl('/login');
    }
    this.cookies.set('apiKey', ak);
    sessionStorage.setItem('apiKey', ak);
  }

  setEmpresa(empresa: IEmpresa) {
    sessionStorage.setItem('Empresa', JSON.stringify(empresa));
  }
  setTipoUser(Tuser: ITipoUsuario) {
    sessionStorage.setItem('TipoUser', JSON.stringify(Tuser));
  }

  setUser(Nombre: string, Email: string, Id: number) {
    const user = {
      Nombre: Nombre,
      Email: Email,
      Id:Id
    };
    sessionStorage.setItem('Usuario', JSON.stringify(user));
  }

  setSession(Data: ILoginResponse) {
    console.log(Data);
    const {Empresas, TipoUser, Nombre, Token, LoginUsuario, Id} = Data;

    this.setEmpresa(Empresas);
    this.setTipoUser(TipoUser);
    this.setToken(Token);
    this.setUser(Nombre, LoginUsuario, Id);
  }


}
